export default "__VITE_ASSET__83219308__"